import transition from 'styled-transition-group';
import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';

export const Frame = transition.div`
	overflow: hidden;
	position: absolute;
	padding-top: ${props => props.ratio};
	background-color: ${getColor('alto')};
	top: 0;
	left: 0;
	width: 100%;
	border-radius: 8px;

	&:enter {
		opacity: 0.01;
	}
	&:enter-active {
		opacity: 1;
		transition: opacity 500ms ease-in;
	}
	&:exit {
		opacity: 1;
	}
	&:exit-active {
		opacity: 0.01;
		transition: opacity 400ms ease-in;
	}

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const ExternalWrapper = styled.div`
	position: relative;
`;

export const Wrapper = styled.div`
	position: relative;
	overflow: hidden;
	padding-top: ${props => props.ratio};
`;
